import React from 'react';
import styled from 'styled-components';
import { Flex } from 'grid-styled';
import session from '../session';

const LogView = styled.div`
    border: 1px solid grey;
    font-family: monospace;
    white-space: pre;
    overflow-y: scroll;
    height: 300px;
`;

class Syslog extends React.Component {
    state = {
        access: '',
        error: ''
    };

    load = async () => {
        try {
            const access = await session.realm.fetch(
                '/sys/cgi-bin/get_icecast_access_logs.cgi'
            );
            const error = await session.realm.fetch(
                '/sys/cgi-bin/get_icecast_error_logs.cgi'
            );

            this.setState({ error, access }, () => {
                if (this._accessLog) {
                    this._accessLog.scrollTop = this._accessLog.scrollHeight;
                }
                if (this._errorLog) {
                    this._errorLog.scrollTop = this._errorLog.scrollHeight;
                }
            });
        } catch (err) {
            console.error('Syslog:' + err);
        }
    };

    async componentDidMount() {
        await this.load();
        this._timer_log = setInterval(this.load, 2000);
    }

    componentWillUnmount() {
        if (this._timer_log) {
            clearInterval(this._timer_log);
        }
    }

    render() {
        const { access, error } = this.state;
        return (
            <Flex flexDirection="column">
                <strong>Access Log</strong>
                <LogView
                    innerRef={ref => (this._accessLog = ref)}
                    style={{ marginBottom: 20 }}
                >
                    {access}
                </LogView>
                <strong>Error Log</strong>
                <LogView innerRef={ref => (this._errorLog = ref)}>
                    {error}
                </LogView>
            </Flex>
        );
    }
}

export default Syslog;



// WEBPACK FOOTER //
// ./src/pages/IcecastLogs.js